<template>
  <j-modal :title="title" :width="1000" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '600px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="false">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('用户编号')">
                <a-input v-model="model.userId" :disabled="disableSubmit"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('用户姓名')">
                <a-input v-model="model.userName" :disabled="disableSubmit"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('用户电话')">
                <a-input v-model="model.userPhone" :disabled="disableSubmit"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('申请类型')">
                <a-input v-model="applyTypeList[model.applyType]" :disabled="disableSubmit"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item :label="$t('申请时间')">
                <a-input v-model="model.createTime" :disabled="disableSubmit"></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('申请原因')">
                <a-textarea v-model="model.applyDescription" :rows="3" :disabled="disableSubmit"/>
              </a-form-model-item>
            </a-col>
            <!-- 用户信息变更 -->
            <template v-if="model.applyType == 3">
              <a-col :span="12">
                <a-form-model-item :label="$t('新用户姓名')">
                  <a-input v-model="model.valueJson.userName" :disabled="disableSubmit"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('新用户电话')">
                  <a-input v-model="model.valueJson.userPhone" :disabled="disableSubmit"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('新用户地址')">
                  <a-input v-model="model.valueJson.userAddr" :disabled="disableSubmit"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('新身份证号')">
                  <a-input v-model="model.valueJson.userIdNumber" :disabled="disableSubmit"></a-input>
                </a-form-model-item>
              </a-col>
            </template>
            <!-- 价格信息变更 -->
            <template v-if="model.applyType == 4">
              <a-col :span="12">
                <a-form-model-item :label="$t('价格信息')">
                  <!-- <a-input v-model="model.valueJson.newPriceId"></a-input> -->
                  <a-select v-model="model.valueJson.newPriceId" :disabled="disableSubmit">
                    <a-select-option v-for="item in priceList" :value="item.id">{{item.wtName}}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('变更方式')">
                  <a-select v-model="model.valueJson.changeWay" :disabled="disableSubmit">
                    <a-select-option :value="1">{{ $t('立即结算') }}</a-select-option>
                    <a-select-option :value="2">{{ $t('扣完再启用新价格') }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('启用日期')">
                  <a-input v-model="model.valueJson.startDate" :disabled="disableSubmit"></a-input>
                </a-form-model-item>
              </a-col>
            </template>
            <!-- 用户过户 -->
            <template v-if="model.applyType == 5">
              <a-col :span="12">
                <a-form-model-item :label="$t('新用户姓名')">
                  <a-input v-model="model.valueJson.userName" :disabled="disableSubmit"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('新用户电话')">
                  <a-input v-model="model.valueJson.userPhone" :disabled="disableSubmit"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('新用户地址')">
                  <a-input v-model="model.valueJson.userAddr" :disabled="disableSubmit"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('新身份证号')">
                  <a-input v-model="model.valueJson.userIdNumber" :disabled="disableSubmit"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('价格信息')">
                  <a-select v-model="model.valueJson.userPriceCode" :disabled="disableSubmit">
                    <a-select-option v-for="item in priceList" :value="item.id">{{item.wtName}}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('用户类型')">
                  <a-select v-model="model.valueJson.userTypeCode" :disabled="disableSubmit">
                    <a-select-option v-for="item in userTypeList" :value="item.id">{{item.utName}}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('身份类型')">
                  <a-select v-model="model.valueJson.userIdType" :disabled="disableSubmit">
                    <a-select-option :value="1">{{ $t('自然人') }}</a-select-option>
                    <a-select-option :value="0">{{ $t('企业') }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('优惠信息')">
                  <a-select v-model="model.valueJson.userFreeinfo" :disabled="disableSubmit">
                    <a-select-option :value="1">{{ $t('按户') }}</a-select-option>
                    <a-select-option :value="2">{{ $t('按人') }}</a-select-option>
                    <a-select-option :value="3">{{ $t('按月') }}</a-select-option>
                    <a-select-option :value="4">{{ $t('按量') }}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
            </template>
            <a-col :span="24">
              <a-form-model-item :label="$t('电子签名')">
                <j-image-upload 
                  class="avatar-uploader" 
                  :text="$t('上传')" 
                  :isMultiple="true" 
                  v-model="model.applySignature" 
                  :disabled="true"
                />
                <!-- <div class="box-sig" @mouseover="isShow = true" @mouseout="isShow = false">
                  <img style="width: 180px;height: 80px;" :src="model.applySignature"/>
                  <div class="mask-sig" :class="{'mask-show':isShow}">
                    <div class="icon-sig" @click="viewSig"><a-icon type="eye" /></div>
                    <div class="icon-sig" @click="downloadSig"><a-icon type="download" /></div>
                  </div>
                </div> -->
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('身份证正反面')">
                <j-image-upload class="avatar-uploader" :text="$t('上传')" :isMultiple="true" v-model="fileList" :disabled="true"></j-image-upload>
                <!-- <JUpload v-model="fileList" @change="uploadChange" /> -->
                <!-- <div>
                  <img style="width: 150px;height: 150px;margin-right: 10px;" :src="JSON.parse(model.userIdCardFront)[0]"/>
                  <img style="width: 150px;height: 150px;" :src="JSON.parse(model.userIdCardOpposite)[0]"/>
                </div> -->
              </a-form-model-item>
            </a-col>
            <div v-if="model.approvalDescription">
              <a-col :span="24">
                <a-form-model-item :label="$t('审批意见')" prop="isAgree">
                  <a-radio-group v-model="model.isAgree" :disabled="disableSubmit">
                    <a-radio :value="1">{{ $t('通过') }}</a-radio>
                    <a-radio :value="0">{{ $t('驳回') }}</a-radio>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item :label="$t('审批描述')" prop="approvalDescription">
                  <a-textarea v-model="model.approvalDescription" :placeholder="$t('请输入审批描述')" :rows="4" :disabled="disableSubmit"/>
                </a-form-model-item>
              </a-col>
            </div>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
    <j-modal title="" :width="448" :visible="visibleSig" @cancel="handleSigCancel" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
      <div style="width: 400px;height: 400px;">
        <img :src="model.applySignature" alt="" style="width: 100%;height: 100%;" />
      </div>
    </j-modal>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import JUpload from '@/components/jeecg/JUpload'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import moment from 'moment';
import { result } from 'lodash';
import JImageUpload from '@/components/jeecg/JImageUpload.vue'
  export default {
    // mixins: [JeecgListMixin],
    name: 'modal',
    components: {JUpload,JImageUpload},
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          add: "/jeecg-charge/oa/oaStopWaterInformation/add",
          edit: "/jeecg-charge/oa/oaStopWaterInformation/edit",
          queryById: "/jeecg-charge/meter/wechatUserApply/queryById",
          priceList: "jeecg-charge/meter/meterPriceinfo/list",
          userTypeList: "/jeecg-charge/meter/meterUserType/list",
        },
        disabledCurrentStart: null,
        disabledCurrentEnd: null,
        fileList:'',
        priceList: [],
        userTypeList: [],
        visibleSig: false,
        isShow: false,
      }
    },
    computed: {
      validatorRules() {
        return {
          stopWaterBegin: [{
            required: true,
            message: this.$t('请选择停水开始时间'),
            trigger: 'change'
          }],
          stopWaterEnd: [{
            required: true,
            message: this.$t('请选择停水结束时间'),
            trigger: 'change'
          }],
          stopWaterRange: [{
            required: true,
            message: this.$t('请输入停水范围'),
            trigger: 'blur'
          }],
          stopWaterCause: [{
            required: true,
            message: this.$t('请输入停水原因'),
            trigger: 'blur'
          }],
        };
      },
      applyTypeList() {
        return ['报停', '报停恢复', '销户', '用户信息变更', '价格信息变更', '用户过户'].map(item => this.$t(item));
      },
    },
    methods: {
      init(row,type){
        this.visible = true;
        // this.model = JSON.parse(JSON.stringify(row));
        getAction(this.url.queryById,{id:row.id}).then(res=>{
          if(res.success){
            this.model = res.result;
            let userIdCardFront = JSON.parse(this.model.userIdCardFront);
            let userIdCardOpposite = JSON.parse(this.model.userIdCardOpposite);
            this.$nextTick(()=>{
              this.$set(this,'fileList',userIdCardFront.concat(userIdCardOpposite).join(','));
            })
            this.model.valueJson = JSON.parse(this.model.valueJson);
            if(type == 'edit'){
              this.title = this.$t('编辑');
              this.disableSubmit = false;
            }else if(type == 'detail'){
              this.title = this.applyTypeList[this.model.applyType] + this.$t('详情');
              this.disableSubmit = true;
            }else{
              this.title = this.$t('新增');
              this.disableSubmit = false;
            }
            if(this.model.applyType == 4 || this.model.applyType == 5) this.getpriceList();
            if(this.model.applyType == 5) this.getuserTypeList();
          }
        })
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.disabledCurrentStart = null
        this.disabledCurrentEnd = null
        this.close()
      },
      handleOk(){
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.close();
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      getpriceList(){
        this.priceList = [];
        getAction(this.url.priceList).then((res)=>{
          if(res.success){
            res.result.records.map(item=>{
              this.priceList.push({
                id: item.id,
                wtName: item.wtName
              })
            })
          }
        })
      },
      getuserTypeList(){
        this.userTypeList = [];
        getAction(this.url.userTypeList).then((res)=>{
          if(res.success){
            res.result.records.map(item=>{
              this.userTypeList.push({
                id: item.id,
                utName: item.utName
              })
            })
          }
        })
      },
      viewSig(){
        this.visibleSig = true;
      },
      handleSigCancel(){
        this.visibleSig = false;
      },
      downloadSig(){
        this.downloadFile(this.model.applySignature, this.$t('签名'))
      },
      downloadFile(url, name) {
        console.log('url==', url)
        var a = document.createElement("a")
        a.setAttribute("href", url)
        a.setAttribute("download", name)
        a.setAttribute("target", "_blank")
        let clickEvent = document.createEvent("MouseEvents")
        clickEvent.initEvent("click", true, true)
        a.dispatchEvent(clickEvent)
      }
    }
  }
</script>
<style lang="less" scoped>
  .box-sig{
    width: 200px;
    height: 100px;
    position: relative;
    border: 1px solid #d9d9d9;
    border-radius:4px;
    display: flex;
    justify-content: center;
    align-items: center;
    .mask-sig{
      visibility: hidden;
      position: absolute;
      width: 180px;
      height: 80px;
      top: 10px;
      left: 10px;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      cursor: pointer;
      
      .icon-sig{
        color: rgba(255, 255, 255, 0.85);
        font-size: 16px;
      }
    }
    .mask-show{
      visibility: visible;
      transition: all 0.3s;
    }
  }
</style>